module.exports = __webpack_public_path__ + "fonts/Gotham-Light.2f3b7a36.eot";